import { Component } from '@angular/core';
import { IonicModule } from '@ionic/angular';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'page-about',
  templateUrl: 'about.html',
  styleUrls: ['./about.scss'],
  standalone: false,
  imports: [
    IonicModule,
    TranslateModule
  ]
})
export class AboutPage {

  public static PATH: string = 'about';

  constructor() {

  }

}
